import { gql } from '@apollo/client';
import { entityReferenceFields, userReferenceFields } from './IDBQueries';

export const IDB_ENTITY_REFERENCE_SUBSCRIPTION = gql`
    subscription {
        data: onEntityReferenceChange {
            ${entityReferenceFields}
        }
    }
`;

export const IDB_USER_REFERENCE_SUBSCRIPTION = gql`
    subscription {
        data: onUserReferenceChange {
            ${userReferenceFields}
        }
    }
`;
